export default __webpack_public_path__ + "static/media/83-min.65780544.jpg";